import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { STATISTIC_PROFIT_BY_DAY } from 'api/query-keys';
import type { TGetProfitStatisticsByDaysRes } from 'api/swagger';
import type { IStatisticProfitFilter } from 'shared/stores/use-statistic-profit-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IStatisticProfitFilter;
}

export const useGetProfitStatisticsByDays = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IStatisticProfitFilter>(qs, filters);

  return useQuery({
    queryKey: [STATISTIC_PROFIT_BY_DAY, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetProfitStatisticsByDaysRes>(`/v1/statistics/profit-in-days?${qs.toString()}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!filters.date && !!filters.userId,
  });
};
